// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopupRemainder_Wrapper__d61_O","fadeIn":"PopupRemainder_fadeIn__CEPhN","BtnAnalog":"PopupRemainder_BtnAnalog__Wy45V"};